{
  "CANNED_MGMT": {
    "HEADER": "Standardsvar Svar",
    "LEARN_MORE": "Learn more about canned responses",
    "DESCRIPTION": "Canned Responses are pre-written reply templates that help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a canned response during a conversation. ",
    "HEADER_BTN_TXT": "Add canned response",
    "LOADING": "Fetching canned responses...",
    "SEARCH_404": "Der er ingen elementer, der matcher denne forespørgsel.",
    "LIST": {
      "404": "Der er ingen tilgængelige standardsvar på denne konto.",
      "TITLE": "Administrer standardsvar",
      "DESC": "Canned Responses are predefined reply templates which can be used to quickly send out replies to conversations.",
      "TABLE_HEADER": {
        "SHORT_CODE": "Short code",
        "CONTENT": "Indhold",
        "INBOXES": "Indbakker",
        "ACTIONS": "Handlinger"
      },
      "ALL_INBOXES": "Alle indbakker",
      "FILTER": {
        "ALL_INBOXES": "Alle indbakker",
        "NO_INBOX": "Ingen indbakke",
        "SEARCH_PLACEHOLDER": "Søg indbakker"
      }
    },
    "ADD": {
      "TITLE": "Add canned response",
      "DESC": "Canned Responses are predefined reply templates which can be used to quickly send out replies to conversations.",
      "CANCEL_BUTTON_TEXT": "Annuller",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Short code",
          "PLACEHOLDER": "Please enter a short code.",
          "ERROR": "Short Code is required."
        },
        "SUBJECT": {
          "LABEL": "Emne (kun e-mail)",
          "PLACEHOLDER": "Valgfrit emne for e-mailsvar / nye samtaler"
        },
        "CONTENT": {
          "LABEL": "Besked",
          "PLACEHOLDER": "Please write the message you want to save as a template to use later.",
          "ERROR": "Message is required."
        },
        "ATTACHMENTS": {
          "LABEL": "Vedhæftede filer"
        },
        "INBOXES": {
          "LABEL": "Indbakker",
          "PLACEHOLDER": "Vælg indbakker (valgfrit, lad stå tomt for alle indbakker)"
        },
        "SUBMIT": "Send"
      },
      "API": {
        "SUCCESS_MESSAGE": "Canned response added successfully.",
        "ERROR_MESSAGE": "Kunne ikke oprette forbindelse til Woot server, Prøv igen senere."
      }
    },
    "EDIT": {
      "TITLE": "Edit canned response",
      "CANCEL_BUTTON_TEXT": "Annuller",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Short code",
          "PLACEHOLDER": "Please enter a shortcode.",
          "ERROR": "Short code is required."
        },
        "SUBJECT": {
          "LABEL": "Emne (kun e-mail)",
          "PLACEHOLDER": "Valgfrit emne for e-mailsvar / nye samtaler"
        },
        "CONTENT": {
          "LABEL": "Besked",
          "PLACEHOLDER": "Please write the message you want to save as a template to use later.",
          "ERROR": "Beskeden er påkrævet."
        },
        "ATTACHMENTS": {
          "LABEL": "Vedhæftede filer"
        },
        "INBOXES": {
          "LABEL": "Indbakker",
          "PLACEHOLDER": "Vælg indbakker (valgfrit, lad stå tomt for alle indbakker)"
        },
        "SUBMIT": "Send"
      },
      "BUTTON_TEXT": "Rediger",
      "API": {
        "SUCCESS_MESSAGE": "Canned response is updated successfully.",
        "ERROR_MESSAGE": "Kunne ikke oprette forbindelse til Woot Server, Prøv igen senere."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Slet",
      "API": {
        "SUCCESS_MESSAGE": "Canned response deleted successfully.",
        "ERROR_MESSAGE": "Kunne ikke oprette forbindelse til Woot Server, Prøv igen senere."
      },
      "CONFIRM": {
        "TITLE": "Bekræft sletning",
        "MESSAGE": "Er du sikker på du vil slette ",
        "YES": "Yes, delete ",
        "NO": "No, keep "
      }
    }
  }
}
